import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import numWords from "num-words";
import "./ManageChallan.css";
import Swal from "sweetalert2";
import logUserActivity from "../utils/logUserActivity";

import image2 from "../../uploads/pinnacle_logo.png";
import {
  PDFDownloadLink,
  Page,
  Text,
  Document,
  PDFViewer,
  StyleSheet,
  View,
  Image,
} from "@react-pdf/renderer";

function ManageChallan() {
  const [data1, setData1] = useState([]);
  const [selectedPDF] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [partyFilter, setPartyFilter] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [filterApplied, setFilterApplied] = useState(false);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getChallan`).then(
      (response) => {
        setData1(response.data);
      },
    );
  }, []);

  const navigate = useNavigate();

  const handleEditForm = async (formId) => {
    const form = data1.find((form) => form._id === formId);
    if (form) {

      navigate("/CreateInvoice", { state: { form, isEditing: true } });
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this challan?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (confirmDelete.isConfirmed) {
      try {
        const challanToDelete = data1.find((item) => item._id === id);

        const response = await Axios.delete(
          `${INVENTORY_API_BASE_URL}/Challandelete/${id}`,
        );

        await logUserActivity("DELETE_CHALLAN", {
          challanId: id,
          deletedData: {
            partyName: challanToDelete?.partyName,
            ChallanNumber: challanToDelete?.ChallanNumber,
            vehicleNumber: challanToDelete?.vehicleNumber,
            NOBoxes: challanToDelete?.NOBoxes,
            transportedBy: challanToDelete?.transportedBy,
            selectedShipmentIds: challanToDelete?.selectedShipmentIds,
            selectedSKUs: challanToDelete?.selectedSKUs,
            Dated: challanToDelete?.Dated,
            station: challanToDelete?.station,
            Ewaybill: challanToDelete?.Ewaybill,
          },
        });

        Swal.fire({
          title: "Deleted!",
          text: "Challan has been deleted successfully.",
          icon: "success",
        }).then(() => {
          window.location.reload();
        });
      } catch (error) {
        console.error("Error deleting challan:", error);
        Swal.fire({
          title: "Error!",
          text: "Failed to delete the challan.",
          icon: "error",
        });
      }
    }
  };




  const generatePDF = (selectedObject) => {
    let total = 0;
    let sum = 0;
    const itemsPerPage = 8;
    const filteredData = data1.filter(
      (item) => item.ChallanNumber === selectedObject.ChallanNumber,
    );

    filteredData.forEach((item) => {
      item.selectedSKUs.forEach((row) => {
        total += parseFloat(row.quantity * row.mrp);
        sum += parseFloat(row.quantity);
      });
    });

    const totalInWords = numWords(total);


    const styles = StyleSheet.create({
      page: {
        flexDirection: "column",
        padding: "1rem",
        border: "5rem",
      },
      section: {
        display: "flex",
        flexDirection: "row",
        marginLeft: 4,
        marginRight: 4,
      },
      title: {
        fontSize: 12,
      },
      listItem: {
        marginBottom: "0.5rem",
      },
      box: {
        border: "1px solid black",
      },
      stationView: {
        border: "1px solid black",
        padding: 5,
      },
      pdfhead: {
        textAlign: "center",
        marginTop: 5,
        marginBottom: 8,
      },

      returnPolicy: {
        fontSize: 11,
        marginTop: 5,
        marginLeft: 10,
        marginBottom: 10,
        textAlign: "left",
      },

      pdfhead2: {
        textAlign: "center",
        fontSize: 12,
      },
      pdfdetails: {
        fontSize: 14,
        marginLeft: 5,
      },
      pdfaddress: {
        fontSize: 12,
      },
      column: {
        flex: 1,
        border: "1px solid black",
      },
      main: {
        marginBottom: 8,
        marginTop: 5,
        marginLeft: 5,
      },
      main2: {
        marginTop: 20,
      },
      details: {
        marginBottom: 5,
      },
      second: {
        fontSize: 11,
      },
      second2: {
        fontSize: 12,
        marginLeft: 12,
      },
      second4: {
        fontSize: 12,
        marginLeft: 12,
        color: "red",
      },
      address: {
        marginLeft: 5,
      },
      secondrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      thirdrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      forthrow: {
        border: "1px solid black",
        marginLeft: 4,
        marginRight: 4,
        marginTop: 8,
      },
      thirdrowquantity: {
        marginLeft: 250,
        fontSize: 13,
      },
      gst: {
        marginLeft: 400,
        fontSize: 13,
        position: "absolute",
      },
      thirdrowbox: {
        border: "1px solid black",
        marginLeft: 5,
        marginRight: 280,
        marginTop: 4,
        marginBottom: 3,
      },
      GD: {
        marginLeft: 380,
        fontSize: 14,
      },
      TA: {
        fontSize: 12,
        marginBottom: 10,
      },
      PP: {
        fontSize: 12,
        marginTop: 5,
        marginLeft: 380,
        marginBottom: 10,
      },
      signature: {
        fontSize: 12,
        marginTop: 30,
        marginLeft: 380,
      },
      returnpol: {
        fontSize: 16,
        marginTop: 5,
        marginLeft: 20,
        marginBottom: 5,
        marginRight: 210,
        border: "1px solid #ccc",
      },
      pdfContent: {
        marginBottom: 10,
      },
      table: {
        marginTop: 10,
        marginBottom: 10,
        fontSize: 12,
      },
      tableRow: {
        flexDirection: "row",
        borderBottomWidth: 1,
        borderBottomColor: "black",
        paddingBottom: 5,
        marginBottom: 5,
        fontSize: 9,
      },
      tableCell: {
        flex: 1,
        padding: 5,
      },
      tableCel: {
        flex: 0.4,
        padding: 2,
      },
      tableCell1: {
        flex: 2,
        padding: 3,
      },
      tableHeaderCell: {
        fontWeight: "bold",
      },
      logo: {
        marginRight: 442,
        position: "absolute",
      },
      mainview: {
        marginLeft: 15,
        marginRight: 15,
      },
    });
    let totalCount = 0;
    const MyDocument = (
      <Document>
        {filteredData.map((item, index) => {
          if (item.selectedSKUs) {
            const numPages = Math.ceil(item.selectedSKUs.length / itemsPerPage);

            return Array.from({ length: numPages }).map((_, pageIndex) => {
              const startIndex = pageIndex * itemsPerPage;
              const endIndex = startIndex + itemsPerPage;
              const itemsToRender = item.selectedSKUs.slice(
                startIndex,
                endIndex,
              );

              const isLastPage = pageIndex === numPages - 1;
              return (
                <Page key={`${index}-${pageIndex}`} style={styles.page}>
                  <View style={styles.mainview}>
                    <View style={styles.main}>
                      <View style={styles.logo}>
                        <Image
                          src={image2}
                          style={{
                            width: 130,
                            height: 60,
                            marginLeft: 12,
                            marginBottom: 2,
                          }} // Adjust the width and height as needed
                        />
                      </View>
                      <Text style={styles.pdfhead2}>
                        PINNACLE CIVIL SERVICES
                      </Text>
                      <Text style={styles.pdfhead2}>
                        1st Floor, 1032A/1, MM Tower, New Railway Road,
                      </Text>
                      <Text style={styles.pdfhead2}>
                        Gurugram, Haryana 122001
                      </Text>
                      <Text style={styles.pdfhead2}>
                        GST: 06AGNPD7273M1ZX , PAN: AGNPD7273M
                      </Text>
                    </View>

                    <View style={styles.section}>
                      <View style={styles.column}>
                        <View style={styles.main2}>
                          <View style={styles.details}>
                            <Text style={styles.pdfdetails}>
                              Party Details :-
                            </Text>
                          </View>
                          <View style={styles.address}>
                            {filteredData.map((item, index) => (
                              <Text key={index} style={styles.pdfaddress}>
                                {item.partyName} : {item.partyAddress}
                              </Text>
                            ))}
                          </View>
                        </View>
                      </View>
                      <View style={styles.column}>
                        <View style={styles.main}>
                          <Text style={styles.second}>
                            Challan Number: {item.ChallanNumber}
                          </Text>
                          <Text style={styles.second}>
                            Dated: {formatDate(item.Dated)}
                          </Text>
                          <Text style={styles.second}>
                            Transport: {item.transportedBy}
                          </Text>
                          <Text style={styles.second}>
                            Vehicle No: {item.vehicleNumber}
                          </Text>
                          <Text style={styles.second}>
                            No. of Boxes/Bundles: {item.NOBoxes}
                          </Text>
                          <Text style={styles.second}>
                            Station: {item.station}{" "}
                          </Text>
                          <Text style={styles.second}>
                            E-Way Bill No: {item.Ewaybill}
                          </Text>
                        </View>
                      </View>
                    </View>

                    <View style={styles.secondrow}>
                      <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeaderCell]}>
                          <View style={styles.tableCell}>
                            <Text>SN</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Particulars </Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>HSN/SAC Code</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Quantity</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>MRP</Text>
                          </View>
                          <View style={styles.tableCell}>
                            <Text>Amount</Text>
                          </View>
                        </View>

                        {itemsToRender.map((updatedItem, updatedIndex) => {
                          totalCount++;
                          return (
                            <View key={updatedIndex} style={styles.tableRow}>
                              <View style={styles.tableCel}>
                                <Text>{totalCount}</Text>
                              </View>
                              <View style={styles.tableCell1}>
                                <Text>
                                  {updatedItem.title} : {updatedItem.medium} :
                                  {updatedItem.edition}
                                </Text>
                              </View>

                              <View style={styles.tableCell}>
                                <Text>{updatedItem.hsnCode}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>{updatedItem.quantity}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>{updatedItem.mrp}</Text>
                              </View>
                              <View style={styles.tableCell}>
                                <Text>
                                  {updatedItem.quantity * updatedItem.mrp}
                                </Text>
                              </View>
                            </View>
                          );
                        })}
                      </View>
                    </View>

                    {isLastPage && (
                      <View>
                        <View style={styles.thirdrow}>
                          <Text style={styles.thirdrowquantity}>
                            Total Quantity: {sum}
                          </Text>

                          <Text style={styles.gst}>GST: Nil</Text>
                          <View style={styles.thirdrowbox}>
                            <Text style={styles.second4}>
                              Make Payment at:-
                            </Text>
                            <Text style={styles.second2}>
                              PINNACLE CIVIL SERVICES
                            </Text>
                            <Text style={styles.second2}>
                              Current Account:- 00000044504305185
                            </Text>
                            <Text style={styles.second2}>
                              IFSC code:-SBIN0016019
                            </Text>
                          </View>

                          <Text style={styles.GD}>GrandTotal:{total} </Text>
                          <Text style={styles.TA}>
                            Total Amount (INR - In Words):-{totalInWords}
                          </Text>
                        </View>

                        <View style={styles.forthrow}>
                          <Text style={styles.returnPolicy}>
                            Return Policy:- Maximum 10% return within 2 months
                            when the new edition is launched
                          </Text>

                          <Text style={styles.PP}>
                            For Pinnacle Civil Services
                          </Text>

                          <Text style={styles.signature}>
                            Authorized Signatory
                          </Text>
                        </View>
                      </View>
                    )}
                  </View>
                </Page>
              );
            });
          }
        })}
      </Document>
    );

    return MyDocument;
  };


  const handleViewPDF = (rowData) => {
    const pdfWindow = window.open("", "_blank");

    if (pdfWindow) {
      pdfWindow.document.write(
        "<html><body><div id='pdf-root'></div></body></html>",
      );
      pdfWindow.document.close();

      const rootElement = pdfWindow.document.getElementById("pdf-root");

      if (rootElement) {
        ReactDOM.createRoot(rootElement).render(
          <PDFViewer width="100%" height="100%">
            {generatePDF(rowData)}
          </PDFViewer>,
        );
      }
    }
  };

  useEffect(() => {
    if (data1.length > 0) {
      const pages = Math.ceil(data1.length / itemsPerPage);
      setTotalPages(pages);
    }
  }, [data1, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const paginate = (array, page_number, page_size) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const getPageRange = () => {
    const maxPagesToShow = 13.5;
    const middlePage = Math.ceil(maxPagesToShow / 2);
    let startPage = Math.max(currentPage - middlePage, 1);
    let endPage = Math.min(startPage + maxPagesToShow - 1, totalPages);

    if (endPage - startPage < maxPagesToShow - 1) {
      startPage = Math.max(endPage - maxPagesToShow + 1, 1);
    }

    endPage = Math.min(endPage, totalPages);

    startPage = Math.max(endPage - maxPagesToShow + 1, 1);

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index,
    );
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const filteredData = data1.filter((row) => {
    const partyMatch = partyFilter
      ? row.partyName.toLowerCase().includes(partyFilter.toLowerCase())
      : true;

    const rowDate = new Date(row.Dated).toISOString().split("T")[0];
    const fromDate = startDate ? new Date(startDate) : null;
    const toDate = endDate ? new Date(endDate) : null;
    const rowDateObj = new Date(rowDate);

    const dateMatch =
      (!fromDate || rowDateObj >= fromDate) &&
      (!toDate || rowDateObj <= toDate);

    if (partyFilter && startDate && endDate) {
      return partyMatch && dateMatch;
    }

    return true;
  });

  const applyFilter = () => {
    const results = data1.filter((row) => {
      const partyMatch = row.partyName
        .toLowerCase()
        .includes(partyFilter.toLowerCase());

      const rowDate = new Date(row.Dated).toISOString().split("T")[0];
      const fromDate = startDate ? new Date(startDate) : null;
      const toDate = endDate ? new Date(endDate) : null;
      const rowDateObj = new Date(rowDate);

      const dateMatch =
        fromDate && toDate && rowDateObj >= fromDate && rowDateObj <= toDate;

      return partyMatch && dateMatch;
    });

    setFilteredResults(results);
    setFilterApplied(true);
  };

  const visibleRows = filterApplied
    ? filteredResults
    : paginate(data1, currentPage, itemsPerPage);
  const visibleTotal = filterApplied ? filteredResults.length : data1.length;
  const rangeStart =
    visibleRows.length === 0
      ? 0
      : filterApplied
        ? 1
        : (currentPage - 1) * itemsPerPage + 1;
  const rangeEnd = filterApplied
    ? filteredResults.length
    : Math.min(currentPage * itemsPerPage, data1.length);

  return (
    <main className="managechallan">
      <div className="managechallan__page">
        <header className="managechallan__header">
          <div>
            <span className="managechallan__eyebrow">INVENTORY OPERATIONS</span>
            <h1>Manage Challan</h1>
            <p>Review, find, and manage your delivery challan records.</p>
          </div>
          <div className="managechallan__recordBadge" aria-label={data1.length + " challan records"}>
            <span aria-hidden="true">▦</span>
            <strong>{data1.length}</strong>
            <span>{data1.length === 1 ? "record" : "records"}</span>
          </div>
        </header>

        <section className="managechallan__filterPanel" aria-labelledby="managechallan-filter-heading">
          <div className="managechallan__filterHeader">
            <div>
              <span className="managechallan__sectionEyebrow">SEARCH AND FILTER</span>
              <h2 id="managechallan-filter-heading">Find challans</h2>
              <p>Select a date range; party name is optional.</p>
            </div>
            <span className="managechallan__filterIcon" aria-hidden="true">⌕</span>
          </div>

          <div className="managechallan__filterGrid">
            <div className="managechallan__field managechallan__field--party">
              <label htmlFor="challan-party-filter">Party name</label>
              <input
                id="challan-party-filter"
                type="text"
                placeholder="Search by party name"
                value={partyFilter}
                onChange={(event) => setPartyFilter(event.target.value)}
              />
            </div>
            <div className="managechallan__field">
              <label htmlFor="challan-start-date">From date</label>
              <input
                id="challan-start-date"
                type="date"
                value={startDate}
                onChange={(event) => setStartDate(event.target.value)}
              />
            </div>
            <div className="managechallan__field">
              <label htmlFor="challan-end-date">To date</label>
              <input
                id="challan-end-date"
                type="date"
                value={endDate}
                onChange={(event) => setEndDate(event.target.value)}
              />
            </div>
            <button
              type="button"
              className="managechallan__button managechallan__button--primary managechallan__applyButton"
              onClick={applyFilter}
            >
              <span aria-hidden="true">⌕</span>
              Apply filters
            </button>
          </div>
        </section>

        <section className="managechallan__tableCard" aria-labelledby="managechallan-table-heading">
          <div className="managechallan__tableHeader">
            <div>
              <span className="managechallan__sectionEyebrow">RECORDS</span>
              <h2 id="managechallan-table-heading">
                {filterApplied ? "Filtered challans" : "Challan register"}
              </h2>
            </div>
            <span className="managechallan__resultCount">
              {visibleTotal} {visibleTotal === 1 ? "challan" : "challans"}
            </span>
          </div>

          <div className="managechallan__tableWrap">
            <Table responsive hover size="sm" className="tableinvoice">
              <thead>
                <tr>
                  <th scope="col">Party name</th>
                  <th scope="col">Order IDs</th>
                  <th scope="col">Challan no.</th>
                  <th scope="col">Transported by</th>
                  <th scope="col">Vehicle no.</th>
                  <th scope="col">Station</th>
                  <th scope="col">Date</th>
                  <th scope="col">Documents</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {visibleRows.length > 0 ? (
                  visibleRows.map((row) => (
                    <tr key={row._id}>
                      <td className="managechallan__partyCell">{row.partyName || "—"}</td>
                      <td className="managechallan__orderCell">
                        {Array.isArray(row.selectedShipmentIds)
                          ? row.selectedShipmentIds.join(", ")
                          : "—"}
                      </td>
                      <td><span className="managechallan__challanNumber">{row.ChallanNumber || "—"}</span></td>
                      <td>{row.transportedBy || "—"}</td>
                      <td>{row.vehicleNumber || "—"}</td>
                      <td>{row.station || "—"}</td>
                      <td className="managechallan__dateCell">{formatDate(row.Dated)}</td>
                      <td>
                        <div className="managechallan__documentActions">
                          <button
                            type="button"
                            className="managechallan__button managechallan__button--document"
                            aria-label={"View PDF for challan " + row.ChallanNumber}
                            onClick={() => handleViewPDF(row)}
                          >
                            View PDF
                          </button>
                          <PDFDownloadLink
                            document={generatePDF(row)}
                            fileName="Challan.pdf"
                            className="managechallan__downloadLink"
                          >
                            {({ loading }) => loading ? "Preparing PDF…" : "Download PDF"}
                          </PDFDownloadLink>
                        </div>
                      </td>
                      <td>
                        <div className="managechallan__rowActions">
                          <button
                            type="button"
                            className="managechallan__button managechallan__button--edit"
                            onClick={() => handleEditForm(row._id)}
                          >
                            Edit
                          </button>
                          <button
                            type="button"
                            className="managechallan__button managechallan__button--delete"
                            aria-label={"Delete challan " + row.ChallanNumber}
                            onClick={() => handleDelete(row._id)}
                          >
                            Delete
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={9} className="managechallan__emptyCell">
                      <div className="managechallan__emptyState">
                        <span className="managechallan__emptyIcon" aria-hidden="true">▤</span>
                        <div>
                          <strong>{filterApplied ? "No matching challans" : "No challans to show"}</strong>
                          <p>
                            {filterApplied
                              ? "Try a different party name or date range."
                              : "Challan records will appear here when available."}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <footer className="managechallan__tableFooter">
            <p>
              Showing {rangeStart}–{rangeEnd} of {visibleTotal}{" "}
              {visibleTotal === 1 ? "challan" : "challans"}
            </p>
            {!filterApplied && data1.length > itemsPerPage && (
              <nav className="managechallan__pagination" aria-label="Challan pages">
                <button
                  type="button"
                  className="managechallan__pageButton managechallan__pageButton--direction"
                  onClick={handlePreviousPage}
                  disabled={currentPage === 1}
                  aria-label="Previous page"
                >
                  ‹ <span>Previous</span>
                </button>
                <div className="managechallan__pageNumbers">
                  {getPageRange().map((pageNumber) => (
                    <button
                      type="button"
                      className={
                        pageNumber === currentPage
                          ? "managechallan__pageButton is-active"
                          : "managechallan__pageButton"
                      }
                      key={pageNumber}
                      onClick={() => handlePageChange(pageNumber)}
                      disabled={pageNumber === currentPage}
                      aria-current={pageNumber === currentPage ? "page" : undefined}
                    >
                      {pageNumber}
                    </button>
                  ))}
                </div>
                <span className="managechallan__pageMeta">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  type="button"
                  className="managechallan__pageButton managechallan__pageButton--direction"
                  onClick={handleNextPage}
                  disabled={currentPage >= totalPages}
                  aria-label="Next page"
                >
                  <span>Next</span> ›
                </button>
              </nav>
            )}
          </footer>
        </section>
      </div>
    </main>
  );
}

export default ManageChallan;
